import { render, staticRenderFns } from "./ApproveSaleModal.vue?vue&type=template&id=e06e08c0&"
import script from "./ApproveSaleModal.vue?vue&type=script&lang=js&"
export * from "./ApproveSaleModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveSaleModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports